import styled, { css } from 'styled-components'

const LINE_HEIGHT = 1.5

const clampToLines = (lines: number) => css`
  & > * {
    display: -webkit-box;
    -webkit-line-clamp: ${lines};
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: ${LINE_HEIGHT};
    max-height: ${lines * LINE_HEIGHT}em;
  }
`

export const WhatsNewPromoCardStyled = styled.div`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  display: grid;
  gap: ${(props) => props.theme.space.medium};
  height: 100%;
`

export const HeroImageStyled = styled.img`
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-radius: ${(props) => props.theme.typography.pxToRem(8)};
`

export const TitleStyled = styled.div`
  ${clampToLines(2)}
`

export const ExcerptStyled = styled.div`
  ${clampToLines(2)}

  a {
    color: ${(props) => props.theme.colors.primary};
    text-decoration: underline;
  }

  strong,
  b {
    font-weight: ${(props) => props.theme.fontWeights.semibold};
  }

  em,
  i {
    font-style: italic;
  }
`

export const CtaStyled = styled.div`
  display: flex;
  justify-content: center;
  align-self: end;
`
